import React from "react";
import type { RelatedHat } from "../../types";
import {
  CarouselDialog,
  CarouselCard,
  CarouselCardImage,
  CarouselCardOverlay,
  CarouselCardName,
} from "./CarouselDialog";
import { SentimentBadge } from "./SentimentBadge";

interface HatViewMoreDialogProps {
  open: boolean;
  onClose: () => void;
  hats: RelatedHat[];
  onHatClick?: (hatId: string) => void;
}

export const HatViewMoreDialog = ({
  open,
  onClose,
  hats,
  onHatClick,
}: HatViewMoreDialogProps) => (
  <CarouselDialog
    open={open}
    onClose={onClose}
    title="Hats You Might Also Like"
  >
    {hats.map((hat) => (
      <CarouselCard key={hat.id} onClick={() => onHatClick?.(hat.id)}>
        {(hat.displayImage?.sizes?.hatCard?.url || hat.displayImage?.url) && (
          <CarouselCardImage
            src={hat.displayImage?.sizes?.hatCard?.url || hat.displayImage?.url}
            alt={hat.displayName}
          />
        )}
        <CarouselCardOverlay>
          <CarouselCardName>{hat.displayName}</CarouselCardName>
        </CarouselCardOverlay>
        <SentimentBadge sentiment={hat.sentiment} />
      </CarouselCard>
    ))}
  </CarouselDialog>
);
